import React from "react";
import pacificopen from "../../images/flyer(4-28-26).jpg";
// import { Button } from "react-bootstrap";

function PacificOpen() {
  return (
    <>
      <div className="row justify-content-center text-center mb-5">
        {/* <a
          href="https://smoothcomp.com/en/event/32002"
          target="_blank"
          rel="noopener noreferrer"
        > */}
        <img src={pacificopen} alt="pacific open" className="eventImg" />
        {/* </a> */}
      </div>
      {/* <div className="row justify-content-center text-center mb-4">
        <div className="col">
          <Button
            href="https://smoothcomp.com/en/event/32002"
            variant="success"
            size="lg"
            target="_blank"
            rel="noopener noreferrer"
          >
            REGISTER HERE
          </Button>
        </div>
      </div>
      <div className="row justify-content-center text-center">
        <p>
          Click{" "}
          <a
            href="https://ibjjf.com/uniform/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{" "}
          for Gi and no-Gi uniform requirements
        </p>
      </div> */}
    </>
  );
}

export default PacificOpen;
